export * from './image-header.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-header/index.ts